// Hook Manager
// ============

// A static class to handle syncronous responses. The primary goal of this class
// is to provide a standard way to allow for customization.

class HookManager {
  constructor() {
    this._hooks = {}
  }

  hook(name, callback, priority = 0) {
    this._hooks[name] = this._hooks[name] || [];
    this._hooks[name].push({
      callback: callback,
      priority: priority
    });
  }
  add_filter(name, callback, priority = 0) {
    this.hook(name, callback, priority);
  }

  unhook(name, callback) {
    if (this._hooks[name] && this._hooks[name].map((h) => h.callback).includes(callback)) {
      this._hooks[name].splcie(this._hooks[name].map((h) => h.callback).indexOf(callback), 1);
    }
  }
  remove_filter(name, callback) {
    this.unhook(name, callback);
  }

  invoke(name, subject, ...args) {
    if (this._hooks[name]) {
      this._hooks[name].sort((a, b) => {
        return b.priority - a.priority;
      });
      this._hooks[name].forEach((hook) => {
        subject = hook.callback.call(null, subject, ...args);
      });
    }
    return subject;
  }
  do_filter(name, subject, ...args) {
    return this.invoke(name, subject, ...args);
  }
}

export default new HookManager();